"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Fraserland Organics
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 2.1.10-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronApi = void 0;
const runtime = __importStar(require("../runtime"));
/**
 * no description
 */
class CronApi extends runtime.BaseAPI {
    /**
     * It finds all tokens that are expired and then deletes them.
     */
    async cronDeAuthenticateTokensGetRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["api-key"] = this.configuration.apiKey("api-key"); // Cron authentication
        }
        const response = await this.request({
            path: `/cron/de_authenticate_tokens`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * It finds all tokens that are expired and then deletes them.
     */
    async cronDeAuthenticateTokensGet() {
        await this.cronDeAuthenticateTokensGetRaw();
    }
    /**
     * Run all the adapters with the sql.
     */
    async cronRunAdaptersGetRaw() {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["api-key"] = this.configuration.apiKey("api-key"); // Cron authentication
        }
        const response = await this.request({
            path: `/cron/run_adapters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Run all the adapters with the sql.
     */
    async cronRunAdaptersGet() {
        await this.cronRunAdaptersGetRaw();
    }
}
exports.CronApi = CronApi;
